import unescapedText from 'I18n/utils/unescapedText';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { ListViewIcon, GridIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StorefrontViewToggle = ({
  activeView,
  onChange
}) => {
  return /*#__PURE__*/_jsxs(ButtonGroup, {
    paddingInlineEnd: "400",
    children: [/*#__PURE__*/_jsx(IconButton, {
      active: activeView === 'list',
      "aria-label": unescapedText('marketplace-assets-ui.storefront.viewToggle.listView'),
      "data-test-id": "storefront-list-view-button",
      onClick: () => {
        onChange('list');
      },
      use: "tertiary-light",
      size: "small",
      children: /*#__PURE__*/_jsx(ListViewIcon, {})
    }), /*#__PURE__*/_jsx(IconButton, {
      active: activeView === 'grid',
      "aria-label": unescapedText('marketplace-assets-ui.storefront.viewToggle.gridView'),
      onClick: () => {
        onChange('grid');
      },
      use: "tertiary-light",
      size: "small",
      children: /*#__PURE__*/_jsx(GridIcon, {
        size: "300"
      })
    })]
  });
};
export default StorefrontViewToggle;